<template>
  <div>
    <div :class="['b-share', size ? size : '']">
      <!-- CRM汎用独自対応 -->
      <!-- <span class="lg:hidden">{{label}}</span>
      <a class="b-share-item lg:hidden" target="_blank" :href="shareFacebook" v-if="facebook">
        <i class="icon icon-bor-facebook" />
      </a>
      <a class="b-share-item lg:hidden" target="_blank" :href="shareTwitter" v-if="twitter">
        <i class="icon icon-bor-twitter" />
      </a>
      <a class="b-share-item lg:hidden" target="_blank" :href="shareLine" v-if="line">
        <i class="icon icon-bor-line" />
      </a> -->
      <!-- <a class="b-share-item lg:hidden" target="_blank" :href="shareEmail" v-if="email">
        <i class="icon icon-bor-envelope" />
      </a>
      <a class="b-share-item lg:hidden" @click="popupMail = true, errCode=''"  v-if="email">
        <i class="icon icon-bor-envelope" />
      </a>
      <PopUpSendMail  :visible="popupMail" @show="showPopup" @sendMail="sendMailToAddress($event)" :errCode="errCode" />
      <div class="divider-v lg:hidden"></div> -->
      <!-- <div class="item-action lg:hidden" v-if="copy">
        <button class="c-btn btn-sm btn-white btn-copy"
                v-clipboard:copy="handleCopyContent()"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError">内容をコピー</button>
      </div> -->
    
      <div class="item-action hidden lg:block sm:hidden">
        <a class="text-grey-600" href="#">
          <i class="icon icon-bor-circle-question" />
        </a>
      </div>
      <!-- <div class="item-action hidden lg:block">
        <a href="#" @click="showShare">
          <i class="icon icon-bor-upload share"></i>
        </a>
      </div> -->
     
      <div class="item-action" v-if="favorite">
        <a @click="handleFavorite">
          <i class="icon icon-bor-heart-solid" v-if="isFavorite" />
          <i class="icon icon-bor-heart-plus" v-else/>
        </a>
      </div>
    </div>
    <InstructionLogin1 :visible="popupLogin" @ok="popupLogin = false" @cancel="popupLogin = false"/>
    <Modal :visible="popupShare" @ok="popupShare = false" @cancel="popupShare = false">
      <div class="b-share_inner">
        <!-- CRM汎用独自対応 -->
        <!-- <a class="b-share-item lg:hidden" target="_blank" :href="shareFacebook" v-if="facebook">
          <i class="icon icon-bor-facebook" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareTwitter" v-if="twitter">
          <i class="icon icon-bor-twitter" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareLine" v-if="line">
          <i class="icon icon-bor-line" />
        </a>
        <a class="b-share-item lg:hidden" target="_blank" :href="shareEmail" v-if="email">
          <i class="icon icon-bor-envelope" />
        </a> -->
        <a v-if="copy" class="b-share-item btn-copy"
                  v-clipboard:copy="handleCopyContent()"
                  v-clipboard:success="copySuccess"
                  v-clipboard:error="copyError">
          <i class="icon icon-bor-copy" />
        </a>
      </div>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash'
import menu_utils from '@/mixins/menu_utils'
import func_utils from '@/mixins/func_utils'

export default {
  name: 'MenuShare',
  mixins: [menu_utils, func_utils],
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'シェア'
    },
    url: {
      type: String
    },
    success: {
      type: Function
    },
    error: {
      type: Function
    },
    facebook: {
      type: Boolean,
      default: true
    },
    twitter: {
      type: Boolean,
      default: true
    },
    line: {
      type: Boolean,
      default: true
    },
    email: {
      type: Boolean,
      default: true
    },
    copy: {
      type: Boolean,
      default: true
    },
    face: {
      type: Boolean,
      default: true
    },
    favorite: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      menuNo: null,
      isFavorite: false,
      favoriteId: null,
      popupLogin: false,
      popupShare: false,
      popupMail: false,
      errCode: '0',
      serviceType: 'tour'
    }
  },
  created() {
    const { menuNo } = this.$route.params
    this.menuNo = menuNo
  },
  mounted() {
    if (this.$auth.loggedIn && this.favorite) {
      this.getFavoriteStatus(this.menuNo, this.serviceType).then(
        (result) => {
          this.favoriteId = _.get(result, 'id', '')
          this.isFavorite = _.get(result, 'favourite', false)
        },
        () => {
          
        })
    }
  },
  watch: {
    
  },
  computed: {
    shareFacebook() {
      if (this.url) {
        return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    },
    shareTwitter() {
      if (this.url) {
        return `https://twitter.com/intent/tweet?text=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://twitter.com/intent/tweet?text=${url}`
    },
    shareLine() {
      if (this.url) {
        return `https://social-plugins.line.me/lineit/share?url=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://social-plugins.line.me/lineit/share?url=${url}`
    },
    shareEmail() {
      if (this.url) {
        return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${this.url}+&ui=2&tf=1&pli=1'`
      }
      // eslint-disable-next-line quotes
      return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${location.href}+&ui=2&tf=1&pli=1'`
    }
  },
  methods: {
    showShare() {
      this.popupShare = true
    },
    handleCopyContent() {
      if (this.url) {
        return this.url
      }
      return location.href
    },
    copySuccess() {
      this.$toasted.success('コピーしました')
    },
    copyError() {
      this.$toasted.error('コピーできません')
    },
    handleFavorite() {
      if (!this.$auth.loggedIn) {
        this.popupLogin = true
        return
      }
      if (!this.isFavorite) {
        this.addFavoriteTour(this.menuNo).then(
          (result) => {
            this.isFavorite = true
            this.favoriteId = _.get(result, 'id', null)
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      } else {
        this.removeFavorite(this.favoriteId).then(
          () => {
            this.favoriteId = null
            this.isFavorite = false
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      }
    },
    sendMailToAddress($event) {
      const menuNo = this.$route.params
      if(!$event) {
        this.errCode = '1'
      } else {
        let myEmail = null
        myEmail = $event.trim()
        if(this.validEmail(myEmail.trim())) {
          const data = {
            menuNo,          
            email: $event
          }
          this.$repositories('plan').sendMailToAddress(data).then(
            () => {
              this.popupMail = false
            },
            (error) => {
              this.popupMail = false
              this.$toasted.error(error?.message)
            }
          )
        } else {
          this.errCode = '2'
        }
      }
    },
    showPopup($event) {
      this.popupMail = $event
    },
    triggerSuccess(type, data) {
      this.$emit('success', {
        type,
        data
      })
    },
    triggerError(type, data) {
      this.$emit('error', {
        type,
        data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>